import React from 'react';
import { aboutContent } from '../../content/about-content';

/**
 * Sources & Citations Section
 *
 * Academic references and further reading.
 */
const SourcesCitations = React.forwardRef(({ id = 'sources' }, ref) => {
  const { citations, furtherReading } = aboutContent;

  return (
    <section id={id} ref={ref} className="about-section">
      <header className="about-section__header">
        <h2 className="about-section__title">
          <svg className="about-section__title-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
            <line x1="8" y1="6" x2="16" y2="6" />
            <line x1="8" y1="10" x2="16" y2="10" />
            <line x1="8" y1="14" x2="12" y2="14" />
          </svg>
          Sources & Citations
        </h2>
        <p className="about-section__subtitle">
          The research and publications that inform our approach.
        </p>
      </header>

      <div className="citations-section">
        <ul className="citations-list">
          {citations.map((citation) => (
            <li key={citation.id} id={`citation-${citation.id}`} className="citation-item">
              <span className="citation-number">{citation.id}</span>
              <div>
                <span className="citation-text">
                  {citation.url ? (
                    <>
                      {citation.text.split(citation.url)[0]}
                      <a
                        href={citation.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="citation-link"
                      >
                        {citation.url}
                      </a>
                    </>
                  ) : (
                    citation.text
                  )}
                </span>
                {citation.category && (
                  <span className="citation-category">{citation.category}</span>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Further Reading */}
      <div className="further-reading">
        <h3 className="further-reading__title">Further Reading</h3>
        <div className="further-reading__list">
          {furtherReading.map((book, index) => (
            <div key={index} className="further-reading__item">
              <h4 className="further-reading__book-title">{book.title}</h4>
              <p className="further-reading__authors">{book.authors}</p>
              <p className="further-reading__desc">{book.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

SourcesCitations.displayName = 'SourcesCitations';

export default SourcesCitations;
